import React, {Component} from "react";
import {
  Divider,
  FormControlLabel,
  CardHeader,
  CardContent,
  FormControl,
  Radio,
  Card,
  Paper,
  RadioGroup,
  FormLabel
} from "@mui/material";
import './css/InverterSelectorForm.css'

export class PhaseView extends Component{

  constructor(props) {
    super(props);
    this.state = {
      
      showNextButton: false,
      showThreePhase: false, 
      showSinglePhase: false,
      phaseData: this.props.phaseTypeData,
    };

  }

  componentDidMount(){

    this.checkPowerRating()

  }

  //Check power ratiing 
  checkPowerRating(){
    if(this.props.powerRating > 17000){
      //console.log("Show only 3 phase")
      this.setState({showSinglePhase: true})
      this.setState({showThreePhase: false})
    }else if(this.props.powerRating < 8000){
      //console.log("lower than 17.5kW")
      this.setState({showSinglePhase: false})
      this.setState({showThreePhase: true})
    }else{
      //do nothing
    }

    if(this.state.phaseData === 1 || this.state.phaseData === 3 ){
      this.setState({showNextButton:true})
      this.props.showNextButton(true);
    }
  }

  phaseTypeSelected = (event) => {

    //this calls the func in inverterselectorforms
    //event target value is the phase type choice
    this.props.phaseFilteredData(event.target.value)
    
    //console.log(event.target.value)

    //this.setState({showNextButton: true});
    
    this.props.showNextButton(true);
    this.props.showPrevButton(true);
  }
   
    render(){

      const { showThreePhase, showSinglePhase} = this.state 


        return (
          //App starts here

          <Card>
            <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }}
              className="paperh-title"
              title="Select Phase Type"     
            />
            <CardContent>

              <Paper elevation={10} className="phase-paper"> 
                <FormControl>
                <FormLabel style={{fontFamily: "Ford-Normal"}}id="demo-radio-buttons-group-label"> 
                Note: if capacity is less than 17kW select Single Phase.if capacity is higher than 17kW select Three Phase                       
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  defaultValue={this.state.phaseData}
                  style={{fontFamily: "Ford-Normal"}}
                  >
                     <Divider/>
                    {!showSinglePhase && <FormControlLabel 
                    sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                      value="1" 
                      control={<Radio />} 
                      label="Single Phase" 
                      onChange={(this.phaseTypeSelected)}
                      />}
                   

                    {!showThreePhase && <FormControlLabel 
                      value="3" 
                      control={<Radio />} 
                      label="Three Phase"
                      onChange={(this.phaseTypeSelected)}
                      sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                      />}
                </RadioGroup>
              </FormControl>              
              </Paper>

            </CardContent>
            {/* <NavRow next={this.props.next} previous={this.props.previous} showNextButton={showNextButton} showPrevButton={true}/> */}
          </Card>
        );
    }
}

export default PhaseView; 